import { MCPToolName } from "@qw/qw-common";

import type { ToolFilter } from "../chat/providers/chat-provider";

export const AUTHORING_CHAT_TOOL_FILTER: ToolFilter = {
  whitelist: [
    MCPToolName.PlaybookDiscovery,
    MCPToolName.PlaybookReader,
    MCPToolName.FindRelevantFiles,
    MCPToolName.SearchFilesForInformation,
    MCPToolName.SearchFileForInformation,
    MCPToolName.DownloadFile,
  ],
};
